import React from "react";
import { DarkModeOutlined, LightModeOutlined, LockOutlined, VerifiedUserOutlined } from "@mui/icons-material";
import { Button, Divider, Paper, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import SignInForm from "../Components/Auth/SignInForm";
import { useGetCartIdforUserMutation } from "../Store/Services/CartService";
import { getGlobalCartId, setGlobalCartId } from "../Utils/cartSession";
import styles from "./SignInPage.module.css";

const SignInPage = ({ themeMode = "light", onThemeToggle }) => {
  const [getUserCartId] = useGetCartIdforUserMutation();

  const toggleTheme = () => {
    if (onThemeToggle) {
      onThemeToggle();
    }
  };

  const handleSuccess = async () => {
    const dataSet = {
      orderHeadId: getGlobalCartId() === "undefined" ? 0 : getGlobalCartId(),
      orderType: 2,
    };

    try {
      const userCartId = await getUserCartId(dataSet).unwrap();
      setGlobalCartId(userCartId.orderHeaderId);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className={`${styles.pageShell} ${themeMode === "dark" ? styles.dark : ""}`}>
      <header className={`${styles.topNav} ${themeMode === "dark" ? styles.darkNav : ""}`}>
        <div className={styles.brandBlock}>
          <div className={styles.brandMark}>N</div>
          <div>
            <Typography className={styles.brandTitle}>N-ACH POS</Typography>
            <Typography className={styles.brandSubtitle}>SMARTER CHECKOUTS. FASTER OPERATIONS.</Typography>
          </div>
        </div>
        <div className={styles.navActions}>
          <Button className={`${styles.iconAction} ${themeMode === "dark" ? styles.darkButton : ""}`} aria-label={themeMode === "dark" ? "Switch to light mode" : "Switch to dark mode"} onClick={toggleTheme}>
            {themeMode === "dark" ? <LightModeOutlined fontSize="small" /> : <DarkModeOutlined fontSize="small" />}
          </Button>
          <Link to="/pos" className={`${styles.navLinkBtn} ${themeMode === "dark" ? styles.darkNavLink : ""}`}>Back to POS</Link>
        </div>
      </header>

      <main className={styles.signInLayout}>
        <section className={styles.visualPanel}>
          <div className={styles.floatingStatLeft}>
            <Typography className={styles.floatTitle}>12 active bills</Typography>
            <Typography className={styles.floatDesc}>Ready at the counter</Typography>
          </div>
          <div className={styles.floatingStatRight}>
            <Typography className={styles.floatTitle}>Register synced</Typography>
            <Typography className={styles.floatDesc}>Pricing and stock updated</Typography>
          </div>
          <div className={styles.modelPlaceholder} aria-hidden="true" />

          <div className={styles.leftCopyBlock}>
            <Typography className={styles.copyEyebrow}>YOUR STORE IS WAITING</Typography>
            <Typography className={styles.copyTitle}>
              Pick up right
              <span> where you left off.</span>
            </Typography>
            <Typography className={styles.copyText}>
              Resume billing, stock checks, and payment operations from one secure POS terminal.
            </Typography>
          </div>
        </section>

        <section className={styles.formPanel}>
          <div className={styles.formHeaderBar}>
            <LockOutlined sx={{ fontSize: 18 }} />
            <span>Secure sign in</span>
          </div>

          <Typography className={styles.formTitle}>
            Sign in to your
            <span> POS terminal.</span>
          </Typography>
          <Typography className={styles.formCaption}>Use your secure cashier account to continue.</Typography>

          <div className={styles.badgesRow}>
            <span>Role-based access</span>
            <span>Encrypted sessions</span>
            <span>Shift-ready access</span>
          </div>

          <Paper className={styles.loginCard} elevation={0}>
            <div className={styles.formBlock}>
              <SignInForm
                onSuccess={handleSuccess}
                showTopLabel={false}
                submitLabel="Sign In"
                submitButtonSx={{
                  background: "linear-gradient(135deg, #3156d6, #3f9ecd)",
                  boxShadow: "0 12px 24px rgba(49, 86, 214, 0.28)",
                  borderRadius: "0.25rem",
                }}
              />
            </div>

            <div className={styles.quickActions}>
              <Button className={styles.createButton} variant="outlined" fullWidth>
                Create Cashier
              </Button>
              <Button className={styles.submitGhost} variant="contained" fullWidth>
                Start Shift
              </Button>
            </div>

            <Divider className={styles.formItem}>Need help?</Divider>
            <div className={styles.actionsRow}>
              <Link to="/forgot-password">
                <Button className={styles.forgotButton} color="secondary" fullWidth>
                  Forgot Password?
                </Button>
              </Link>
            </div>

            <div className={styles.securityNote}>
              <VerifiedUserOutlined sx={{ fontSize: 16 }} />
              <span>Private, encrypted and role-protected access.</span>
            </div>
          </Paper>
        </section>
      </main>

      <footer className={styles.bottomFooter}>
        <Typography>N-ACH POS</Typography>
        <Typography>© 2026 N-ACH CRM Powered by N-ACH</Typography>
      </footer>
    </div>
  );
};

export default SignInPage;
